import React, { useState } from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import AppButton from '../../Components/MerchantButton';
import './UnifiedFormStyles.css';

const QRPHDoorHangerMerch = ({ navigation }) => {
  const [present, setPresent] = useState("");

  const handleBack = () => {
    navigation.previous();
  };

  const handleNext = () => {
    if (!present) {
      toast.error('Please select Yes or No', { autoClose: 2000, hideProgressBar: true, theme: 'colored' });
      return;
    }
    if (present === 'Yes') {
      if (navigation && navigation.go) navigation.go('qrph-door-hanger-details');
    } else if (present === 'No') {
      if (navigation && navigation.go) navigation.go('not-visible-qrph');
    }
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">QRPH Door Hanger Merchandising</h4>
              <p className="form-desc">Record QRPH door hanger details.</p>
            </div>
            <div className="form-main">
              <div className="form-main-content">
                <Form>
                 
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">Visible QRPH Door Hanger</Form.Label>
                    <div className="form-radio-group">
                      <div className={`form-radio-item${present === 'Yes' ? " selected" : ""}`}>
                        <div className="form-radio-flex">
                          <Form.Check
                            type="radio"
                            name="qrph_door_hanger_visible"
                            value="Yes"
                            label="Yes"
                            checked={present === 'Yes'}
                            onChange={(e) => setPresent(e.target.value)}
                            className="form-radio"
                          />
                        </div>
                      </div>
                      <div className={`form-radio-item${present === 'No' ? " selected" : ""}`}>
                        <div className="form-radio-flex">
                          <Form.Check
                            type="radio"
                            name="qrph_door_hanger_visible"
                            value="No"
                            label="No"
                            checked={present === 'No'}
                            onChange={(e) => setPresent(e.target.value)}
                            className="form-radio"
                          />
                        </div>
                      </div>
                    </div>
                  </Form.Group>

                  <div className="form-nav-btns">
                    <AppButton onClick={handleBack} variant="back" className="form-btn variant-secondary">
                      ← Back 
                    </AppButton>
                    <AppButton onClick={handleNext} variant="next" className="form-btn variant-primary">
                     Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default QRPHDoorHangerMerch;
